import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { useSession, signIn } from "next-auth/react";
import axios from 'axios';
import { useUserStore } from '@/stores/useUserStore';
import { User } from '@/stores/initialState';
import Link from 'next/link';
import AlertDialog from '../Utils/AlertDialog';


const SignUp = () => {
  const router = useRouter();
  const { sbind, redirect } = router.query;
  const { userInfo, getUser, updateUser } = useUserStore();
  const { data, status } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userData, setUserData] = useState(getUser());
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setUserData(getUser());
  }, [getUser, userInfo])

  useEffect(() => {
    const checkInput = async () => {
      if (firstName === "" || firstName.length === 0) {
        setMessage("Please enter your first name");
      } else if (lastName === "" || lastName.length === 0) {
        setMessage("Please enter your last name");
      } else if (email === "" || email.length === 0) {
        setMessage("Please enter your email");
      } else if (password === "" || password.length === 0) {
        setMessage("Please enter your password");
      } else if (password.length < 6) {
        setMessage("Password needs more than six characters.");
      } else {
        await processRegister();
      }
    }

    const processRegister = async () => {
      handleRegister()
        .then((response) => {
          handleUpdateUser(response)
        })
        .then(() => {
          handleRedirect()
        })
        .catch((error) => {
          switch (error.response.data.error) {
            case "already have this customer":
            case "This user already registered.":
              setMessage("This account has already been registered, please log in again");
              break;

            case "email is empty":
              setMessage("email cannot be empty");
              break;

            case "password is empty":
              setMessage("password cannot be empty");
              break;

            case "Password needs more than six characters.":
              setMessage("Password needs more than six characters.");
              break;

            case "Facebook OAuth valid failed":
              setMessage("here was an error while process Facebook Login, please refresh this page and try again.");
              break;

            case "Google OAuth login failed":
              setMessage("here was an error while process Google Login, please refresh this page and try again.");
              break;

            default:
              setMessage("here was an error while process register, please refresh this page and try again.");
          }
        });
    }

    const handleRegister = async () => {
      let body = {
        "username": userData.uuid,
        "user_id": userData.user_id,
        "email": email,
        "password": password,
        "name": lastName + " " + firstName,
        "logintype": 'email',
        "social_network_id": "",
        "access_token": "",
        "action": "register",
      }

      if (status === 'authenticated') {
        body.logintype = data.provider;
        body.email = data.user.email;

        if (data.provider === 'facebook') {
          body.social_network_id = data.user.id;
          body.access_token = data.user.accessToken;
        } else if (data.provider === 'google') {
          body.social_network_id = data.user.id;
        }
      }

      const response = await axios.post("/api/auth", body);

      return response.data;
    }

    const handleUpdateUser = async (response: any) => {
      let user: User = {
        user_id: response.user_id,
        email: response.email,
        level: response.membership_level,
        token: response.token,
        barcode: '',
        mooimom_point: 0,
        name: lastName + " " + firstName,
        phone: '',
        referral_code: '',
        uuid: userData.uuid,
        refresh_token: response.refresh_token,
        country_code: '',
        birthday: null,
        gender: ''
      }

      updateUser(user);
      setUserData(user);
    }

    const handleRedirect = () => {
      if (redirect != undefined) {
        if (typeof(redirect) === 'string') {
          router.push(redirect);
        } else {
          router.push(redirect[0]);
        }
      } else {
        router.push('./');
      }
    }

    if (status === 'authenticated') {
      if (sbind != undefined) {

      }

      processRegister();
    }

    if (userData.level !== "none" && userData.email !== null) {
      handleRedirect();
    }

    const registerBtn = document.getElementById("registerBtn");

    if (registerBtn !== null) {
      registerBtn.addEventListener("click", checkInput);

      return () => {
        registerBtn.removeEventListener('click', checkInput);
      };
    }
  }, [data, email, firstName, lastName, password, redirect, router, sbind, status, updateUser, userData.email, userData.level, userData.user_id, userData.uuid])

  useEffect(() => {
    if (message !== "") {
      setOpen(true);
    }
  }, [message]);

  useEffect(() => {
    if (!open) {
      setMessage("");
    }
  }, [open]);

  return (
    <div className="w-full grid gird-cols-1 md:grid-cols-2 gap-12 md:items-center mb-[69px] md:mb-0">
      <div className="hidden w-full md:block">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/login-desktop.jpg"}
          alt="login image"
          width={900}
          height={921}
          quality={100}
        />
      </div>
      <div className="w-full md:hidden">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/login-mobile.jpg"}
          alt="login image"
          width={600}
          height={400}
          quality={100}
        />
      </div>
      <div className="mx-[35px] md:mx-auto md:w-[400px] font-dmsans">
        <div className="flex items-end justify-between">
          <h1 className="text-[24px] md:text-[32px] leading-8 md:leading-[42px] font-bold text-[#2C3E2F] text-center md:text-left w-full">Register</h1>
        </div>
        <div className="flex mt-6 text-sm font-medium text-[#2C3E2F] justify-center md:justify-start">
          <p className="mr-2">Already have an account??</p>
          <Link href="/login">
            <p className="underline">Login here</p>
          </Link>
        </div>
        <input
          type="text"
          name="First name"
          value={firstName}
          placeholder="First Name"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setFirstName(event.target.value)}
        />
        <input
          type="text"
          name="Last name"
          value={lastName}
          placeholder="Last Name"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setLastName(event.target.value)}
        />
        <input
          type="text"
          name="email"
          value={email}
          placeholder="username@gmail.com"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setEmail(event.target.value)}
        />
        <div className="relative mt-6">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={password}
            placeholder="Password"
            className="w-full py-4 px-8 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
            onChange={event => setPassword(event.target.value)}
          />
          <Image
            src={showPassword ? process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/eye-slash.svg" : process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/eye.svg"}
            alt="eye icon"
            width={20}
            height={20}
            quality={100}
            className="absolute -translate-y-1/2 cursor-pointer right-6 top-1/2"
            onClick={() => setShowPassword(!showPassword)}
          />
        </div>
        <div className="flex justify-center mt-6 text-xs font-normal text-[#2C3E2F]">
          <p>I already read and agree with the&nbsp;<Link href="/privacy-policy"><span className="underline">Privacy Policy</span></Link>&nbsp;applied.</p>
        </div>
        <button
          className="bg-[#A6CAA6] w-full text-white text-base font-medium py-4 px-12 text-center mt-6"
          id="registerBtn"
        >
          Create Account
        </button>
        {/* <div className="flex justify-center my-6">
          <p className="text-base font-normal text-[#2C3E2F]">
            or create account with
          </p>
        </div>
        <div className="flex justify-center">
          <button
            className=""
            onClick={() => signIn("google")}
          >
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/google.png"}
              alt="google icon"
              quality={100}
              width={32}
              height={32}
              className=""
            />
          </button>
          <button
            className=""
            onClick={() => signIn("facebook")}
          >
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/facebook.png"}
              alt="google icon"
              quality={100}
              width={32}
              height={32}
              className="ml-4"
            />
          </button>
        </div> */}
      </div>
      <AlertDialog message={message} open={open} setOpen={setOpen} />
    </div>
  )
}

export default SignUp;
